/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
import { useTracking } from 'react-tracking';
import { useTranslation } from '../../src/i18n';
import SocialIcon from '../Icons/SocialIcons';
import classes from '../Icons/SocialIcons/SocialIcons.module.scss';
import { trackEvent } from '../../utils/tracking';
import { TP } from '../../constants/consts';
import styles from './SocialLinks.module.scss';

const SocialLinks = ({ socialLinks, iconClass }) => {
  const tracking = useTracking();
  const { t } = useTranslation();
  const socialNetworkSites = socialLinks?.filter(item => item.type !== 'cuetv');
  const socialPresence = socialNetworkSites?.filter(item => item.type !== 'other');
  const cueTvCollection = socialLinks?.filter(item => item.type === 'cuetv');
  const otherSites = socialLinks?.filter(item => item.type === 'other');
  const otherSitesLinks = otherSites?.map(site => site?.link);

  return (
    <div className={classes.socialLinksBlock}>
      {(socialPresence?.length > 0 || cueTvCollection?.length > 0) && (
        <>
          {socialPresence?.map((socialLink, index) => (
            <div
              key={`${socialLink?.link}-${index}`}
              className={classes.linkesBlock}
              onClick={() =>
                tracking.trackEvent(
                  trackEvent({
                    name: 'click_social_link',
                    data: { 'Click URL': socialLink.link, click_url_type: socialLink.type },
                  }),
                )
              }
            >
              <SocialIcon iconClass={iconClass} url={socialLink.link} type={socialLink.type} />
            </div>
          ))}
          {cueTvCollection?.map((socialLink, index) => (
            <div
              key={`${socialLink?.link}-${index}`}
              className={classes.linkesBlock}
              onClick={() =>
                tracking.trackEvent(
                  trackEvent({
                    name: 'click_social_link',
                    data: { 'Click URL': socialLink.link, click_url_type: socialLink.type },
                  }),
                )
              }
            >
              <SocialIcon iconClass={iconClass} url={socialLink.link} type={socialLink.type} />
            </div>
          ))}
          {otherSites?.length > 0 && (
            <Tooltip
              title={otherSitesLinks?.join(', ')}
              placement="right"
              classes={{
                tooltip: styles.darkTooltip,
              }}
            >
              <span className={styles.otherUrls}>
                &nbsp;(+{otherSites?.length} {t(`${TP}.MORE`)} other links)
              </span>
            </Tooltip>
          )}
        </>
      )}
    </div>
  );
};

SocialLinks.propTypes = {
  socialLinks: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string.isRequired,
      type: SocialIcon.propTypes.type,
    }).isRequired,
  ),
  iconClass: PropTypes.string,
};
SocialLinks.defaultProps = {
  socialLinks: [],
};

export default SocialLinks;
